// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const ConnectCheckoutDemo: MarkdocTagRegistration = {
  tag: 'connect-checkout-demo',
  component: 'ConnectCheckoutDemo',
  attributes: {
    type: {
      type: String,
      required: true,
      default: 'connect-direct-charge-checkout',
      description:
        'connect-destination-charge-checkout or connect-direct-charge-checkout (the same as the GitHub sample name)',
    },
  },
};
